module.exports = __webpack_public_path__ + "img/07.05cf125f.png";